function recorder_start() {
  return import(
    /* webpackChunkName: "page-recorder-start" */ '@/pages/recorder-start.vue'
  )
}
function _404_index() {
  return import(
    /* webpackChunkName: "page-404-index" */ '@/pages/404/index.vue'
  )
}
function chatbot_index() {
  return import(
    /* webpackChunkName: "page-chatbot-index" */ '@/pages/chatbot/index.vue'
  )
}
function dashboard_index() {
  return import(
    /* webpackChunkName: "page-dashboard-index" */ '@/pages/dashboard/index.vue'
  )
}
function document_index() {
  return import(
    /* webpackChunkName: "page-document-index" */ '@/pages/document/index.vue'
  )
}
function guide_index() {
  return import(
    /* webpackChunkName: "page-guide-index" */ '@/pages/guide/index.vue'
  )
}
function release_index() {
  return import(
    /* webpackChunkName: "page-release-index" */ '@/pages/release/index.vue'
  )
}
function roadmap_index() {
  return import(
    /* webpackChunkName: "page-roadmap-index" */ '@/pages/roadmap/index.vue'
  )
}
function team_index() {
  return import(
    /* webpackChunkName: "page-team-index" */ '@/pages/team/index.vue'
  )
}
function welcome_index() {
  return import(
    /* webpackChunkName: "page-welcome-index" */ '@/pages/welcome/index.vue'
  )
}
function dashboard_share() {
  return import(
    /* webpackChunkName: "page-dashboard-share" */ '@/pages/dashboard/share.vue'
  )
}
function release_detail_index() {
  return import(
    /* webpackChunkName: "page-release-detail-index" */ '@/pages/release/detail/index.vue'
  )
}
function roadmap_dialog() {
  return import(
    /* webpackChunkName: "page-roadmap-dialog" */ '@/pages/roadmap/dialog.vue'
  )
}
function share_expired() {
  return import(
    /* webpackChunkName: "page-share-expired" */ '@/pages/share/expired.vue'
  )
}
function share_login() {
  return import(
    /* webpackChunkName: "page-share-login" */ '@/pages/share/login.vue'
  )
}
function team_dialog() {
  return import(
    /* webpackChunkName: "page-team-dialog" */ '@/pages/team/dialog.vue'
  )
}
function support_center_email_config_index() {
  return import(
    /* webpackChunkName: "page-support-center-email-config-index" */ '@/pages/support-center/email-config/index.vue'
  )
}
function support_center_requesters_index() {
  return import(
    /* webpackChunkName: "page-support-center-requesters-index" */ '@/pages/support-center/requesters/index.vue'
  )
}
function support_center_tickets_index() {
  return import(
    /* webpackChunkName: "page-support-center-tickets-index" */ '@/pages/support-center/tickets/index.vue'
  )
}

export default [
  {
    name: 'recorder-start',
    path: 'recorder-start',
    component: recorder_start,
  },
  {
    name: '404',
    path: '404',
    component: _404_index,
    meta: {
      hidden: true,
      hideAside: true,
      simple: true,
      hideHeader: true,
    },
  },
  {
    name: 'chatbot',
    path: 'chatbot',
    component: chatbot_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: '机器人聊天',
      userSwitch: ['automation_chatgpt_switch'],
    },
  },
  {
    name: 'dashboard',
    path: 'dashboard',
    component: dashboard_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'route.home',
    },
  },
  {
    name: 'document',
    path: 'document',
    component: document_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'navbar.document',
    },
  },
  {
    name: 'guide',
    path: 'guide',
    component: guide_index,
    meta: {
      hidden: true,
      hideAside: true,
      simple: true,
      hideHeader: true,
    },
  },
  {
    name: 'release',
    path: 'release',
    component: release_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'navbar.release',
    },
  },
  {
    name: 'roadmap',
    path: 'roadmap',
    component: roadmap_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'route.roadmap',
    },
  },
  {
    name: 'team',
    path: 'team',
    component: team_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'navbar.teams',
    },
  },
  {
    name: 'welcome',
    path: 'welcome',
    component: welcome_index,
  },
  {
    name: 'dashboard-share',
    path: 'dashboard/share',
    component: dashboard_share,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'route.home',
      innerShare: true,
    },
  },
  {
    name: 'release-detail',
    path: 'release/detail',
    component: release_detail_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'route.releaseVersion',
    },
  },
  {
    name: 'roadmap-dialog',
    path: 'roadmap/dialog',
    component: roadmap_dialog,
  },
  {
    name: 'share-expired',
    path: 'share/expired',
    component: share_expired,
    meta: {
      hidden: true,
      share: true,
      hideAside: true,
      hideHeader: true,
      simple: true,
    },
  },
  {
    name: 'share-login',
    path: 'share/login',
    component: share_login,
    meta: {
      hidden: true,
      share: true,
      hideAside: true,
      hideHeader: true,
      simple: true,
    },
  },
  {
    name: 'team-dialog',
    path: 'team/dialog',
    component: team_dialog,
  },
  {
    name: 'support-center-email-config',
    path: 'support-center/email-config',
    component: support_center_email_config_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'navbar.supportCenter.emailConfig',
    },
  },
  {
    name: 'support-center-requesters',
    path: 'support-center/requesters',
    component: support_center_requesters_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'navbar.supportCenter.requesters',
    },
  },
  {
    name: 'support-center-tickets',
    path: 'support-center/tickets',
    component: support_center_tickets_index,
    meta: {
      hidden: true,
      hideHeader: true,
      simple: true,
      title: 'navbar.supportCenter.tickets',
    },
  },
]
